// src/utils/storage.ts

const storage = sessionStorage; // change here only

export default storage;